import { compareGroupLabels } from "@/run-detail/compare-by"

import type { ScatterPoint } from "./buildScatterDataset"

interface LegendEntry {
  groupKey: string
  label: string
  color: string
}

// Distinct Compare By groups among the plotted points, sorted by label. The
// scatter is a single <Scatter> with per-<Cell> colors, so Recharts can't
// derive legend entries natively; this feeds the card-footer legend row.
// Points without a group (no Compare By match) carry no legend entry.
// First-point-wins for color/label is safe: buildScatterDataset derives both
// solely from the groupKey, so they're constant within a group.
export function buildLegendEntries(points: ScatterPoint[]): LegendEntry[] {
  const byGroupKey = new Map<string, LegendEntry>()
  for (const point of points) {
    if (point.groupKey == null || byGroupKey.has(point.groupKey)) {
      continue
    }
    byGroupKey.set(point.groupKey, {
      groupKey: point.groupKey,
      label: point.groupLabel ?? point.groupKey,
      color: point.color,
    })
  }
  return Array.from(byGroupKey.values()).sort((a, b) =>
    compareGroupLabels(a.label, b.label),
  )
}
